/**
 * 得意度に応じたclassNameを返す関数
 * @param especially
 * @returns {string}
 */
export const getEspeciallyClassName = (especially) => {
    let className;
    switch (especially) {
        case 0:
            className = 'is-normal';
            break;
        case 1:
            className = 'is-especially';
            break;
        default:
            className = 'is-none';
    }
    return className;
};
export default getEspeciallyClassName;
